import * as React from 'react';

import { useChatMessageMenu } from './provider';
import { useMenuItems } from './useMenuItems';
import { ChatMessageContextMenu } from '../../components/ChatMessageContextMenu';
import { ChatMessageMenu } from '../../components/ChatMessageMenu';
import { EDeviceType } from '../../types/deviceType';
import { useApplicationContext } from '../../utils/applicationContext';
import { useRuntimeSetting } from '../../hooks/useRuntimeSetting';

export const ChatMessageMenuContainer: React.FC = () => {
  const { chatMessageMenuState, hideChatMessageMenu } = useChatMessageMenu();
  const menuItems = useMenuItems(chatMessageMenuState?.chatId, chatMessageMenuState?.messageId);

  const {
    custom: { realDevice },
  } = useApplicationContext();

  const isEnabled = useRuntimeSetting<boolean>('frontend-chats.deleteMessagesFeature.Enabled', false);
  const isMobile = realDevice !== EDeviceType.Desktop;

  const onShowMenu = React.useCallback(() => {}, []);

  if (!isEnabled || !chatMessageMenuState || menuItems.length === 0) {
    return null;
  }

  if (isMobile) {
    return (
      <ChatMessageMenu
        messageId={chatMessageMenuState.messageId}
        chatId={chatMessageMenuState.chatId}
        menuItems={menuItems}
        onShow={onShowMenu}
        onClose={hideChatMessageMenu}
      />
    );
  }

  return (
    <ChatMessageContextMenu
      onCloseContextMenu={hideChatMessageMenu}
      messageId={chatMessageMenuState.messageId}
      chatId={chatMessageMenuState.chatId}
      menuItems={menuItems}
      left={chatMessageMenuState.x}
      top={chatMessageMenuState.y}
    />
  );
};
